import TabTrap from "../../core/utils/tabTrap";
import eventBus from "../../core/services/event-bus";
import { elementExists } from "../../core/utils";

const HeaderNav = function () {
  const toggleNav = document.querySelector('#toggle-nav');
  const toggleTakeover = document.querySelector('#toggle-takeover');
  const takeover = document.querySelector('.nav-takeover');
  const body = document.querySelector('body');
  const takeoverTabTrap = new TabTrap('.nav-takeover');
  takeoverTabTrap.removeTabIndexes();

  // Open Nav
  if (toggleNav) {
      toggleNav.addEventListener('click', (event) => {
          takeoverTabTrap.on();
          takeover.classList.add('show');
          body.classList.add('scroll-lock');
      })
  }

  // Close Nav
  if (toggleTakeover) {
      toggleTakeover.addEventListener('click', (event) => {
          takeoverTabTrap.off();
          takeover.classList.remove('show');
          body.classList.remove('scroll-lock');
      })
  }

  /* Show and hide the navbar */
  const mainHeader = document.querySelector('#main-header-wrap');
  // let navbar = document.querySelector('.navbar');
  let navbar = mainHeader;
  const navHeight = navbar.offsetHeight;
  const offset = navHeight * 0.4;

  document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);

  let lastY = window.pageYOffset;
  function updateNavbar() {
    if (window.pageYOffset > navHeight - offset) {
      navbar.classList.add('show');
      if ( window.pageYOffset < lastY ) {
        mainHeader.classList.remove('hide');
      } else {
        mainHeader.classList.add('hide');
      }
    } else {
      mainHeader.classList.remove('hide');
      navbar.classList.remove('show');
    }
    lastY = window.pageYOffset;
  }
  window.addEventListener('scroll', updateNavbar);

  /* Search panel toggle */
  const searchToggles = document.querySelectorAll('.toggle-search');
  const searchPanel = document.querySelector('.nav-search');
  const searchInput = searchPanel.querySelector('#input_search');
  const searchTabTrap = new TabTrap('.nav-search', searchInput);
  searchTabTrap.removeTabIndexes();
  let searchPanelOpen = false;
  searchToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      searchPanel.classList.toggle('show');
      if (searchPanelOpen = !searchPanelOpen) {
        searchTabTrap.on();
      } else {
        searchTabTrap.off();
      }
    })
  })
  /** Update the cart button when there is something in there */
  const btnCart = document.querySelector('.btn-cart');
  if( elementExists( btnCart ) ){
    eventBus.on( eventBus.types.CartUpdated , e => {
      if( e.detail.item_count > 0 ){
        btnCart.classList.remove( 'empty')
      }else{
        btnCart.classList.add( 'empty')
      }
    })
  }
}
  
export default HeaderNav;